<template>
  <v-row align-center justify-center>
    <v-col cols="12">
      <v-card class="text-left">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('Формирование платежных поручений') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-row class="my-1">
          <v-col>
            <v-progress-linear :active="isLoading" color="blue" indeterminate />
            <general-error v-if="!!generalError" />
          </v-col>
        </v-row>
        <v-expansion-panels multiple>
          <v-expansion-panel v-if="!isAdmin">
            <v-expansion-panel-header>
              <div id="accessPayment">
                {{ $t('Плата за доступ в СЭТ ВР') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-btn
                  id="accessPaymentBtn"
                  v-test="{ btn: 'accessPaymentTemplate' }"
                  color="primary"
                  @click.stop="generateAccessPaymentTemplate">
                {{ $t('Сформировать') }}
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isAdmin">
            <ValidationObserver ref="paymentForInformation" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="paymentForInformation">
                  {{ $t('Оплата Сбора за получение информации, способствующей заключению Договора') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col cols="6">
                    <validatable-dynamic-text-input
                        id="informationSum"
                        v-model="informationSum"
                        v-test="{ input: 'informationSum' }"
                        :readonly="false"
                        :rules="{ required: true,
                                  regex: /^[0-9]{1,11}([.][0-9]{0,2})?$/ }"
                        :label="$t('Сумма к оплате')" />
                  </v-col>
                  <v-col cols="6" align-self="center">
                    <v-btn
                        id="paymentForInformationBtn"
                        v-test="{ btn: 'paymentForInformationTemplate' }"
                        color="primary"
                        :disabled="!isInformationSumFilled"
                        @click.stop="generatePaymentForInformationTemplate">
                      {{ $t('Сформировать') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import ValidatableDynamicTextInput from '@/components/reused/ui/ValidatableDynamicTextInput.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { PAYMENT_PURPOSE_TYPES } from '@/constants/business'
  import { mapActions } from 'vuex'
  import { PAYMENT_TEMPLATES_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableDynamicTextInput,
      GeneralError
    },
    data () {
      return {
        isLoading: false,
        securityDepositSum: null,
        informationSum: null,
        paymentOfPurchaseLotNumber: null,
        penaltyTransferLotNumber: null
      }
    },
    computed: {
      isSecurityDepositSumFilled () {
        return !!this.securityDepositSum
      },
      isInformationSumFilled () {
        return !!this.informationSum
      },
      isPaymentOfPurchaseLotNumberFilled () {
        return !!this.paymentOfPurchaseLotNumber
      },
      isPenaltyTransferLotNumberFilled () {
        return !!this.penaltyTransferLotNumber
      }
    },
    methods: {
      ...mapActions(PAYMENT_TEMPLATES_MANAGEMENT.NAMESPACE, {
        getTemplateAction: PAYMENT_TEMPLATES_MANAGEMENT.ACTIONS.GET_TEMPLATE
      }),
      generateAccessPaymentTemplate: async function () {
        try {
          this.isLoading = true
          await this.getTemplateAction({
            paymentPurposeTypesEnum: PAYMENT_PURPOSE_TYPES.ACCESS_PAYMENT
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      generatePaymentForInformationTemplate: async function () {
        try {
          const result = await this.$refs.paymentForInformation.validate()
          if (!result) {
            return
          }
          this.isLoading = true
          const params = { sum: this.informationSum }
          await this.getTemplateAction({
            paymentPurposeTypesEnum: PAYMENT_PURPOSE_TYPES.PAYMENT_FOR_INFORMATION,
            params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }

</script>
